// 保存登录用户信息
export const SAVE_USER_INFO = 'SAVE_USER_INFO';

// 清空登录用户信息
export const EMPTY_USER_INFO = 'EMPTY_USER_INFO';
